import React, { useState } from "react";
import {
  DataGrid,
  gridClasses,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHomeContext } from "../../context/HomeContext";
import { useAuth } from "../../context/auth";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { ThreeDots } from "react-loader-spinner";
import { useThemeContext } from "../../context/ThemeContext";
const CompanyRequest = () => {
  const [request, setRequest] = useState([]);
  const [acceptedData, setAcceptedData] = useState([]);
  const [rejectedData, setRejectedData] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const { currentMode, setCurrentMode } = useThemeContext();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const requestData = useQuery(
    ["requestDataApi"],
    async () =>
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}company/request`, {
        headers,
      }),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setRequest(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );
  console.log(requestData?.data);
  //accepted requestes
  const acceptedRequestData = useQuery(
    ["acceptedTRequestDataApi"],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}company/request-accepted`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setAcceptedData(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );

  //rejected request
  const rejectedRequestData = useQuery(
    ["rejectedTRequestDataApi"],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}company/request-rejected`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setRejectedData(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );
  const columns = [
    { field: "index", headerName: "ID", width: 70, headerAlign: "left" },
    {
      field: "logo",
      headerName: "Logo",
      width: 90,
      renderCell: (params) => {
        console.log({ params: params });
        return (
          <img src={params?.row?.logo} alt="" className="h-10 rounded-md" />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 160,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },

    {
      field: "phone",
      headerName: "phoneNo",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "email",
      headerName: "email",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "address",
      headerName: "address",
      width: 210,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "action",
      headerName: "action",
      width: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center space-x-3">
            <Link to={"/company/detail/" + params.row._id}>
              <button
                className="bg-blue-bg rounded-sm text-center
                     px-3 p-1 font-medium text-sm text-white capitalize"
              >
                Detail
              </button>
            </Link>
          </div>
        );
      },
    },
  ];

  //accepted columns
  const acceptedColumns = [
    { field: "index", headerName: "ID", width: 70, headerAlign: "left" },
    {
      field: "logo",
      headerName: "Logo",
      width: 90,
      renderCell: (params) => {
        console.log({ params: params });
        return (
          <img src={params?.row?.logo} alt="" className="h-10 rounded-md" />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 160,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },

    {
      field: "phone",
      headerName: "phoneNo",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "email",
      headerName: "email",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "address",
      headerName: "address",
      width: 210,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
  ];

  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        // color="secondary"
        // variant="outlined"
        shape="rounded"
        page={page + 1}
        count={pageCount}
        // @ts-expect-error
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }
  return (
    <div className="p-3 md:p-5 ">
      <div className="bg-white dark:bg-secondary-dark-bg p-2 md:p-5 rounded-lg">
        <div className="flex flex-col  space-y-2 py-4 ">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl">
            Company/Request
          </h1>

          {requestData.isFetched ? (
            requestData?.data?.data?.data?.length > 0 ? (
              request?.length > 0 ? (
                <div style={{ height: 520 }} className="">
                  <DataGrid
                    rows={request}
                    columns={columns}
                    pageSize={8}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    getRowId={(row) => row._id}
                    sx={{
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      "& .super-app-theme--header": {
                        borderColor:
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        border: "none",
                      },
                      color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                      border: 2,
                      borderColor:
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      [`& .${gridClasses.cell}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                      },
                      [`& .${gridClasses.row}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        textAlign: "center",
                      },
                      "& .MuiDataGrid-cellCenter": {
                        justifyContent: "center",
                      },
                      "&.MuiDataGrid-root .MuiDataGrid-cell": {
                        outline: "none",
                        textAlign: "left",
                        border: "none",
                      },
                      "& .MuiPaginationItem-root": {
                        color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                        // backgroundColor:'red'
                        border: "none",
                      },
                    }}
                    components={{
                      Pagination: CustomPagination,
                    }}
                  />
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="#216fed"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              )
            ) : (
              <div className="flex items-center justify-center w-full text-center">
                <h1
                  className="capitalize text-dark-gray text-2xl
           font-bold text-center"
                >
                  You have no Company Request
                </h1>
              </div>
            )
          ) : (
            <div className="flex items-center justify-center">
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#216fed"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
        </div>

        {/* accepted request */}
        <div className="flex flex-col  space-y-2 py-4 ">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl">
            Accepted Requests
          </h1>

          {acceptedRequestData.isFetched ? (
            acceptedRequestData?.data?.data?.data?.length > 0 ? (
              acceptedData?.length > 0 ? (
                <div style={{ height: 520 }} className="">
                  <DataGrid
                    rows={acceptedData}
                    columns={acceptedColumns}
                    pageSize={8}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    getRowId={(row) => row._id}
                    sx={{
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      "& .super-app-theme--header": {
                        borderColor:
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        border: "none",
                      },
                      color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                      border: 2,
                      borderColor:
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      [`& .${gridClasses.cell}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                      },
                      [`& .${gridClasses.row}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        textAlign: "center",
                      },
                      "& .MuiDataGrid-cellCenter": {
                        justifyContent: "center",
                      },
                      "&.MuiDataGrid-root .MuiDataGrid-cell": {
                        outline: "none",
                        textAlign: "left",
                        border: "none",
                      },
                      "& .MuiPaginationItem-root": {
                        color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                        // backgroundColor:'red'
                        border: "none",
                      },
                    }}
                    components={{
                      Pagination: CustomPagination,
                    }}
                  />
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="#216fed"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              )
            ) : (
              <div className="flex items-center justify-center w-full text-center">
                <h1
                  className="capitalize text-dark-gray text-2xl font-bold 
          text-center"
                >
                  You have no accepted company request
                </h1>
              </div>
            )
          ) : (
            <div className="flex items-center justify-center">
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#216fed"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
        </div>
        {/* rejected */}
        <div className="flex flex-col  space-y-2 py-4 ">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl">
            Rejected Requests
          </h1>

          {rejectedRequestData.isFetched ? (
            rejectedRequestData?.data?.data?.data?.length > 0 ? (
              rejectedData?.length > 0 ? (
                <div style={{ height: 520 }} className="">
                  <DataGrid
                    rows={rejectedData}
                    columns={acceptedColumns}
                    pageSize={8}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    getRowId={(row) => row._id}
                    sx={{
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      "& .super-app-theme--header": {
                        borderColor:
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        border: "none",
                      },
                      color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                      border: 2,
                      borderColor:
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      [`& .${gridClasses.cell}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                      },
                      [`& .${gridClasses.row}`]: {
                        borderColor: (theme) =>
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        textAlign: "center",
                      },
                      "& .MuiDataGrid-cellCenter": {
                        justifyContent: "center",
                      },
                      "&.MuiDataGrid-root .MuiDataGrid-cell": {
                        outline: "none",
                        textAlign: "left",
                        border: "none",
                      },
                      "& .MuiPaginationItem-root": {
                        color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                        // backgroundColor:'red'
                        border: "none",
                      },
                    }}
                    components={{
                      Pagination: CustomPagination,
                    }}
                  />
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="#216fed"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              )
            ) : (
              <div className="flex items-center justify-center w-full text-center">
                <h1
                  className="capitalize text-dark-gray text-2xl font-bold 
          text-center"
                >
                  You have no rejected company request
                </h1>
              </div>
            )
          ) : (
            <div className="flex items-center justify-center">
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#216fed"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
        </div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover={false}
          transition={Slide}
        />
      </div>
    </div>
  );
};

export default CompanyRequest;
